import React, { useEffect, useContext } from 'react';
import { Switch, Route } from 'react-router-dom';

import { AuthContext, appActions } from './context/AuthContext';
import { Auth } from 'aws-amplify';

import HomePage from './pages/';
import SignIn from './pages/auth/SignIn';
import ForgotPassword from './pages/auth/ForgotPassword';
import NewPasswordRequired from './pages/auth/NewPasswordRequired';

import ForgotPasswordVerification from './pages/auth/ForgotPasswordVerification';
import PrivateRoute from './components/PrivateRoute';
import AccountIndex from './pages/account';
import ChangePassword from './pages/account/ChangePassword';
import Loading from './components/Loading';
import AudiobookDetail from './pages/titleManagement/AudiobookDetail';
import UserList from './pages/admin/UserList';
import UserCreate from './pages/admin/UserCreate';
import NotFound from './pages/NotFound';
import SearchableTable from './pages/SearchableTable';
import Chat from './pages/chat';
import ChatWidget from './components/chat/ChatWidget';
import ReactHintFactory from 'react-hint';
const ReactHint = ReactHintFactory(React);

const App = () => {
    const { state, dispatch } = useContext(AuthContext);
    useEffect(() => {
        async function persistLogin() {
            dispatch({ type: appActions.PERSIST_LOGIN_START });
            try {
                const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
                dispatch({ type: appActions.PERSIST_LOGIN_SUCCESS, payload: { user } });
            } catch (error) {
                dispatch({ type: appActions.PERSIST_LOGIN_FAIL, payload: { error } });
            }
        }
        persistLogin();
    }, [dispatch]);

    if (state.isLoading) {
        return (
            <div className="p-5">
                <Loading />
            </div>
        );
    }

    return (
        <>
            <Switch>
                <PrivateRoute exact path="/" component={HomePage} />
                <Route path="/sign-in">
                    <SignIn />
                </Route>
                <Route path="/forgot-password">
                    <ForgotPassword />
                </Route>
                <Route path="/forgot-password-verification">
                    <ForgotPasswordVerification />
                </Route>
                <Route path="/new-password-required">
                    <NewPasswordRequired />
                </Route>

                <PrivateRoute exact path="/account" component={AccountIndex} />
                <PrivateRoute path="/account/change-password" component={ChangePassword} />

                <PrivateRoute path="/search" component={SearchableTable} />

                <PrivateRoute path="/chat" component={Chat} />

                <PrivateRoute exact path="/admin/users" component={UserList} />
                <PrivateRoute path="/admin/users/add" component={UserCreate} />

                <PrivateRoute path="/title-management/:contentId" component={AudiobookDetail} />

                <Route component={NotFound} />
            </Switch>
            {/* Outside the Switch so the conversation survives navigation. */}
            <ChatWidget />
            <ReactHint events persist className="react-hint-secondary" position="top" />
        </>
    );
};

export default App;
